var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customEventThemeColorInsert_empty"> <div class="control-group customEventThemeColorInsert_inputPush"> <div class="forms-sample"> <div class="form-group" style="margin-bottom:0px">  <input class="form-control form-control-sm" id="customEventThemeColorInsert_inputPush"> <span class="help-inline" style="color:red"></span> <div class="form-check form-check-flat form-check-primary"> <button type="button" class="btn btn-primary btn-sm col-sm-3" id="customEventThemeColorInsert_btnPushSubmit">'+
((__t=( resources['X101535'] ))==null?'':__t)+
'</button> </div> </div> </div> </div> </div>';
}
return __p;
};
